<template>
  <div
    v-if="value"
    class="mr-2 mt-2 py-2 bg-white rounded-lg shadow-xl"
    style="position: fixed; z-index: 10; width: 200px"
    :ref="`dropdown_${_uid}`"
    id="r-dropdown"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "r-dropdown",

  // props
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  /**
   * Hook to life cycle and
   * append listeners.
   */
  mounted() {
    document.addEventListener("mousedown", this.closeByClick)
    document.addEventListener("keydown", this.closeByEsc)
  },

  /**
   * Hook into lifecycle and remove
   * listeneres.
   */
  beforeDestroy() {
    document.removeEventListener("mousedown", this.closeByClick)
    document.removeEventListener("keydown", this.closeByEsc)
  },

  // methods
  methods: {
    /**
     * Emit the close event.
     */
    close() {
      this.$emit("input", false)
    },

    /**
     * Detect ESC keypress and close dialog.
     */
    closeByEsc(e) {
      if (e.key === "Escape") {
        this.close()
      }
    },

    /**
     * Detect outside click and close dialog.
     */
    closeByClick(e) {
      // get element
      const elem = this.$refs[`dropdown_${this._uid}`]

      // find click outside
      if (!e.target.closest("#r-dropdown")) {
        if (elem) {
          this.close()
        }
      }
    }
  }
}
</script>
